import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import isFunction from 'lodash/isFunction'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import FormControl from './FormControl'

export default class SelectInput extends FormControl {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    placeholder: PropTypes.string,
    helpText: PropTypes.string,
    initialValue: PropTypes.any,
    simpleValue: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.array.isRequired,
    validationFuncs: PropTypes.array,
    loading: PropTypes.bool,
    selectDarkSkin: PropTypes.bool,
    multiple: PropTypes.bool,
    searchable: PropTypes.bool,
    clearable: PropTypes.bool,
    backspaceRemoves: PropTypes.bool,
    deleteRemoves: PropTypes.bool,
    extendedClass: PropTypes.string,
    onBlurExternal: PropTypes.func,
    isGroup: PropTypes.bool
  }

  static defaultProps = {
    disabled: false,
    validationFuncs: [],
    loading: false,
    multiple: false,
    initialValue: '',
    simpleValue: false,
    selectDarkSkin: false,
    searchable: true,
    clearable: true,
    backspaceRemoves: true,
    deleteRemoves: true,
    isGroup: true
  }

  getValue() {
    return this.state.value
  }

  handleBlur = () => {
    this.validate()

    if (isFunction(this.props.onBlurExternal)) {
      this.props.onBlurExternal()
    }
  }

  render() {
    const {
      id,
      label,
      labelClass,
      placeholder,
      disabled,
      helpText,
      options,
      loading,
      multiple,
      simpleValue,
      searchable,
      clearable,
      extendedClass,
      backspaceRemoves,
      deleteRemoves,
      helpTextClassName
    } = this.props

    const groupClass = classNames({
      'form-group': !this.props.isGroup ? this.props.isGroup : true,
      'has-danger': !this.state.isValid,
      [extendedClass]: !!extendedClass
    })

    const labelClassName = classNames({
      'margin-bottom-0-5': true,
      [labelClass]: !!labelClass
    })

    return (
      <fieldset className={groupClass} id={id}>
        {label && (
          <label htmlFor={id} className={labelClassName}>
            {label}
          </label>
        )}
        <div className="input-wrapper">
          <Select
            ref={id}
            name={id}
            value={this.state.value}
            simpleValue={simpleValue}
            placeholder={placeholder}
            searchable={searchable}
            clearable={clearable}
            disabled={disabled}
            options={options}
            onBlur={this.handleBlur}
            onChange={this.handleChange}
            isLoading={loading}
            multi={multiple}
            backspaceRemoves={backspaceRemoves}
            deleteRemoves={deleteRemoves}
          />
        </div>
        {helpText && <small className={helpTextClassName ? this.props.helpTextClassName : 'text-muted'}>{helpText}</small>}
        {this.state.errorMessage && <small className="text-danger">{this.state.errorMessage}</small>}
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/SelectInput.jsx